import {colors} from "@material-ui/core";

export default {
  root: {
    color: '#343434',
    fontSize: 20,
    'fontFamily': 'century-gothic',
  },
};
